import {createAction, createReducer} from '@reduxjs/toolkit';

import {STEPS} from 'desktop/pages/checkout/constants/checkout';
import {StatusType} from 'desktop/types/statusType';

export const initialState: StatusType = {
    [STEPS.DELIVERY_STEP]: {
        completed: false,
        editing: false,
        loaded: false,
    },
    [STEPS.PAYMENT_STEP]: {
        completed: false,
        editing: false,
        loaded: false,
    },
};

export const changeStepStatus = createAction<StatusType>('CHECKOUT@CHANGE_STEP_STATUS');

export const saveStepStatus = createAction<StatusType>('CHECKOUT@SAVE_STEP_STATUS');

export const resetCheckoutSteps = createAction('CHECKOUT@RESET_CHECKOUT_STEPS');

/**
 * Status
 *
 * @return {StatusType} status
 */
export const status = createReducer<StatusType>(initialState, builder => {
    builder
        .addCase(resetCheckoutSteps, () => initialState)
        .addCase(saveStepStatus, (state, action) => ({
            ...state,
            ...action.payload,
        }));
});
